export const PAC_GH_APP_NEW = 'https://github.com/settings/apps/new';
export const PAC_GH_APP_DOC =
  'https://docs.github.com/en/developers/apps/getting-started-with-apps/about-apps#about-github-apps';
export const PAC_GH_APP_MANIFEST_API = 'https://api.github.com/app-manifests';
export const EVENT_LISTNER_NAME = 'pipelines-as-code-interceptor';
export const PAC_SECRET_NAME = 'pipelines-as-code-secret';
export const PAC_GH_APP_NAME = 'pipelines-ci-clustername';
export const PAC_INFO = 'pipelines-as-code-info';
export const PAC_TEMPLATE_DEFAULT = 'pipelines-as-code-pipelinerun-generic';
